import PropTypes from 'prop-types';
import "./PullQuote.css";

const renderText = (value) => {
  if (typeof value === "string") {
    return value
  } else {
    return <span dangerouslySetInnerHTML={{__html: value.props.value}} />
  }
}

const PullQuote = (props) => {
  const {
    displayName = 'PullQuote',
    value = ''
  } = props;
  return (
    <div className={displayName}>
      {renderText(value)}
    </div>
  )
}

PullQuote.propTypes = {
  displayName: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ])
}

export default PullQuote;

